<template>
  <div>
    <!-- Поля EPrimeryRabot -->
    <TextAreaStyled
      :data="entry.name"
      :is-flat="true"
      :placeholder="'Название'"
      :rows-count="'1'"
      :is-loading="$store.state.loadingRequestGeneral"
      @update-input="updateEntryLocal('name', $event)"
    />
    <v-text-field
      v-model="entry.code"
      label="code — url детальной страницы"
      disabled
      hide-details
      class="mb-3"
    />
    <TextAreaStyled
      :data="entry.description"
      :is-flat="true"
      :placeholder="'Описание'"
      :rows-count="'3'"
      class="pt-3 pb-3"
      :is-loading="$store.state.loadingRequestGeneral"
      @update-input="updateEntryLocal('description', $event)"
    />

    <SearchStyled
      class="mb-3"
      :is-id="entry.id_company"
      :is-items="$store.state.Companies.listCompanies"
      :is-item-text="'name'"
      :is-item-value="'id'"
      :is-placeholder="'Компания'"
      :is-loading="$store.state.loadingRequestGeneral"
      :is-disabled="!entry.id || $store.state.loadingRequestGeneral"
      :is-clearable="true"
      :is-return-object="false"
      @change-search="updateEntryLocal('id_company', $event)"
    />
    <SearchStyled
      class="mb-3"
      :is-id="entry.id_city"
      :is-items="$store.state.PrimeryKotelnyh.listCities"
      :is-item-text="'city'"
      :is-item-value="'id'"
      :is-placeholder="'Город'"
      :is-loading="$store.state.loadingRequestGeneral"
      :is-disabled="!entry.id || $store.state.loadingRequestGeneral"
      :is-clearable="true"
      :is-return-object="false"
      @change-search="updateEntryLocal('id_city', $event)"
    />
    <SearchStyled
      class="mb-3"
      :is-id="entry.id_module_scheme"
      :is-items="$store.state.PrimeryKotelnyh.listModuleSchemes"
      :is-item-text="'name'"
      :is-item-value="'id'"
      :is-placeholder="'Схема'"
      :is-loading="$store.state.loadingRequestGeneral"
      :is-disabled="!entry.id || $store.state.loadingRequestGeneral"
      :is-clearable="true"
      :is-return-object="false"
      @change-search="updateEntryLocal('id_module_scheme', $event)"
    />

    <!-- Секции — только когда запись создана -->
    <v-expansion-panels
      v-if="entry.id"
      class="mt-4"
      flat
      multiple
      v-model="expandedPanels"
    >
      <v-expansion-panel
        style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
      >
        <v-expansion-panel-header class="text-caption text--secondary">
          Номенклатура шаблона
          <span
            v-if="listTemplateNomenclaturesSpec.length"
            class="ml-1 grey--text"
          >
            ({{ listTemplateNomenclaturesSpec.length }})
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- Таблица существующих записей с drag-and-drop -->
          <table
            v-if="draggableTemplateList.length"
            class="template-table mb-2"
          >
            <thead>
              <tr>
                <th style="width: 28px"></th>
                <th style="width: 70px">№</th>
                <th>Тэг</th>
                <th>Номенклатура</th>
                <th style="width: 90px">Кол-во</th>
                <th style="width: 36px"></th>
              </tr>
            </thead>
            <draggable
              v-model="draggableTemplateList"
              tag="tbody"
              handle=".drag-handle"
              animation="150"
              @end="onTemplateListDragEnd"
            >
              <tr v-for="row in draggableTemplateList" :key="row.id">
                <td>
                  <v-icon small class="drag-handle" color="grey lighten-1"
                    >mdi-drag-vertical</v-icon
                  >
                </td>
                <td class="text--secondary">{{ row.label_number }}</td>
                <td>
                  <span class="text-caption">{{
                    (row._tag && row._tag.name) || "—"
                  }}</span>
                </td>
                <td>
                  <div class="d-flex flex-wrap py-1" style="gap: 4px">
                    <v-chip
                      v-for="nId in row.ids_nomenclatures"
                      :key="nId"
                      x-small
                      label
                    >
                      {{ getNomenclatureName(nId) }}
                    </v-chip>
                  </div>
                </td>
                <td>
                  <v-text-field
                    :value="row.quantity"
                    type="number"
                    min="1"
                    dense
                    hide-details
                    style="max-width: 72px"
                    :disabled="$store.state.loadingRequestGeneral"
                    @change="onTemplateRowQtyChange(row, $event)"
                  />
                </td>
                <td>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="deleteTemplateRow(row.id)"
                  >
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </draggable>
          </table>

          <!-- Форма добавления новой строки -->
          <div
            v-if="draftTemplateRow"
            class="pa-3 mb-2"
            style="
              border: 1px dashed #90caf9;
              border-radius: 4px;
              background: #f5f9ff;
            "
          >
            <div class="text-caption text--secondary mb-2">Новая строка</div>
            <div class="d-flex align-start flex-wrap" style="gap: 8px">
              <div style="flex: 0 0 220px">
                <SearchStyled
                  :is-id="draftTemplateRow.id_tag"
                  :is-items="$store.state.TagsModule.listTags"
                  :is-item-text="'name'"
                  :is-item-value="'id'"
                  :is-placeholder="'Тэг'"
                  :is-loading="$store.state.loadingRequestGeneral"
                  :is-clearable="true"
                  :is-return-object="false"
                  @change-search="draftTemplateRow.id_tag = $event"
                />
              </div>
              <v-autocomplete
                v-model="draftTemplateRow.ids_nomenclatures"
                :items="$store.state.PrimeryKotelnyh.listNomenclatures"
                :item-text="getProductName"
                item-value="id"
                label="Номенклатура"
                multiple
                chips
                small-chips
                deletable-chips
                outlined
                dense
                hide-details
                :menu-props="{ maxHeight: '60vh' }"
                style="flex: 1 1 260px; min-width: 200px"
                :disabled="$store.state.loadingRequestGeneral"
              />
              <v-text-field
                v-model.number="draftTemplateRow.quantity"
                type="number"
                min="1"
                label="Кол-во"
                outlined
                dense
                hide-details
                style="flex: 0 0 80px"
                :disabled="$store.state.loadingRequestGeneral"
              />
            </div>
            <div class="d-flex mt-2" style="gap: 8px">
              <v-btn
                small
                color="success"
                :loading="$store.state.loadingRequestGeneral"
                :disabled="!draftTemplateRow.ids_nomenclatures.length"
                @click="saveDraftTemplateRow"
              >
                Сохранить
              </v-btn>
              <v-btn small @click="cancelDraftTemplateRow">Отмена</v-btn>
            </div>
          </div>

          <v-btn
            v-if="!draftTemplateRow"
            small
            outlined
            color="primary"
            :disabled="$store.state.loadingRequestGeneral"
            @click="addDraftTemplateRow"
          >
            <v-icon left small>mdi-plus</v-icon>
            Добавить строку
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        class="mt-2"
        style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
      >
        <v-expansion-panel-header class="text-caption text--secondary">
          Фотографии (спецификации)
          <span v-if="listSpecs.length" class="ml-1 grey--text"
            >({{ listSpecs.length }})</span
          >
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="pa-0">
            <!-- Ряд превью + дропзона -->
            <div class="d-flex flex-wrap align-center" style="gap: 12px">
              <div
                v-for="(spec, i) in listSpecs"
                :key="spec.id"
                class="spec-thumb"
                :class="{ 'spec-thumb--active': selectedSpecIndex === i }"
                @click="
                  selectedSpecIndex = i;
                  editedHotspotIndex = null;
                "
              >
                <img v-if="spec._image" :src="spec._image.thumb_path" alt="" />
                <div v-else class="spec-thumb__placeholder">
                  <v-icon color="grey">mdi-image</v-icon>
                </div>
                <v-btn
                  class="spec-thumb__remove"
                  icon
                  x-small
                  color="error"
                  @click.stop="onRemoveSpec(spec.id)"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>

              <!-- Дропзона — добавить новое фото -->
              <vue-dropzone
                id="PrimeryRabotDropzone"
                ref="dropzone"
                :options="dropzoneOptions"
                :use-custom-slot="true"
                class="spec-dropzone"
                :class="{
                  loading_dropzone: $store.state.loadingRequestGeneral,
                }"
                @vdropzone-success="onSpecUploaded"
                @vdropzone-sending="onDropzoneSending"
              >
                <div
                  class="d-flex flex-column align-center justify-center"
                  style="height: 100%"
                >
                  <v-icon
                    color="grey lighten-1"
                    size="40"
                    style="transform: rotate(45deg)"
                  >
                    mdi-image-filter-center-focus
                  </v-icon>
                  <div class="caption grey--text mt-1">Добавить фото</div>
                </div>
              </vue-dropzone>
            </div>

            <!-- Редактор хотспотов выбранной спецификации -->
            <template v-if="selectedSpec">
              <v-divider class="mt-4" />
              <div class="spec-editor-zone pa-4">
                <div class="d-flex align-center mb-4" style="gap: 16px">
                  <div class="text-caption text--secondary flex-shrink-0">
                    Фото {{ selectedSpecIndex + 1 }}
                  </div>
                  <!-- Тэг = вкладка в публичном интерфейсе -->
                  <div style="flex: 0 0 280px">
                    <SearchStyled
                      :is-id="selectedSpec.id_tag"
                      :is-items="$store.state.TagsModule.listTags"
                      :is-item-text="'name'"
                      :is-item-value="'id'"
                      :is-placeholder="'Вкладка (тэг) *'"
                      :is-loading="$store.state.loadingRequestGeneral"
                      :is-clearable="true"
                      :is-return-object="false"
                      :is-class="!selectedSpec.id_tag ? 'error-outlined' : ''"
                      @change-search="updateSpecTag($event)"
                    />
                    <div
                      v-if="!selectedSpec.id_tag"
                      class="error--text"
                      style="font-size: 11px; padding: 2px 12px 0"
                    >
                      Обязательное поле
                    </div>
                  </div>
                </div>

                <v-text-field
                  :value="specTitleImage"
                  label="SEO title изображения"
                  outlined
                  dense
                  disabled
                  persistent-hint
                  hint="Формируется автоматически: «Вкладка (тэг)»: «Название проекта»"
                  class="mb-4"
                />

                <div
                  ref="imageWrapper"
                  class="diagram-wrapper"
                  @click="onImageClick"
                >
                  <img
                    :src="selectedSpec._image.orig_path"
                    class="diagram-image"
                    :style="isAddingHotspot ? 'cursor:crosshair' : ''"
                    alt=""
                    @load="imageLoaded = true"
                    width="802"
                    height="601"
                  />
                  <div
                    v-for="(spot, i) in selectedSpec._hotspots"
                    :key="spot.id || i"
                    class="hotspot-dot"
                    :class="{
                      saved: spot.id,
                      editing: editedHotspotIndex === i,
                    }"
                    :style="{
                      left: spot.hotspot_x + 'px',
                      top: spot.hotspot_y + 'px',
                    }"
                    @click.stop="
                      editedHotspotIndex = i;
                      isAddingHotspot = false;
                    "
                  >
                    {{ spot.label_number }}
                  </div>
                </div>

                <!-- Кнопки управления -->
                <div class="d-flex mt-4" style="gap: 8px">
                  <v-btn
                    color="primary"
                    small
                    :disabled="
                      isAddingHotspot || !imageLoaded || !selectedSpec.id_tag
                    "
                    @click="startAddHotspot"
                  >
                    {{
                      isAddingHotspot
                        ? "Кликните по изображению..."
                        : "Добавить метку"
                    }}
                  </v-btn>
                  <v-btn
                    small
                    color="error"
                    :disabled="editedHotspotIndex === null"
                    @click="removeHotspot(editedHotspotIndex)"
                  >
                    Удалить метку
                  </v-btn>
                  <v-btn
                    v-if="
                      selectedSpec._hotspots && selectedSpec._hotspots.length
                    "
                    color="warning"
                    class="ml-auto"
                    small
                    :loading="isDeletingAll"
                    @click="clearAllHotspots"
                  >
                    Очистить все метки ({{ selectedSpec._hotspots.length }})
                  </v-btn>
                </div>

                <!-- Форма текущей метки -->
                <div
                  v-if="editedHotspotIndex !== null && editedHotspot"
                  class="mt-4 pa-4"
                  style="
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                  "
                >
                  <div class="subtitle-2 mb-3">
                    Метка {{ editedHotspotIndex + 1 }} ({{
                      editedHotspot.hotspot_x
                    }}px, {{ editedHotspot.hotspot_y }}px)
                    <span
                      v-if="editedHotspot.label_number"
                      class="ml-2 grey--text font-weight-regular"
                    >
                      — №{{ editedHotspot.label_number }}
                    </span>
                  </div>
                  <div class="d-flex align-start mb-2" style="gap: 12px">
                    <!-- Шаблон -->
                    <v-autocomplete
                      v-model="selectedTemplateForHotspot"
                      :items="listTemplateNomenclaturesSpec"
                      :item-text="getTemplateName"
                      item-value="id"
                      label="Шаблон"
                      clearable
                      outlined
                      dense
                      hide-details
                      style="flex: 1; min-width: 0"
                      :disabled="
                        $store.state.loadingRequestGeneral || !!editedHotspot.id
                      "
                      @change="onTemplateSelectedForHotspot"
                    />
                    <!-- Количество -->
                    <v-text-field
                      v-model="editedHotspot.quantity"
                      :disabled="
                        $store.state.loadingRequestGeneral ||
                        !!editedHotspot.id ||
                        !selectedTemplateForHotspot
                      "
                      clearable
                      type="number"
                      label="Кол-во"
                      outlined
                      dense
                      hide-details
                      style="flex: 0 0 90px"
                    />
                  </div>
                  <!-- Номенклатура на всю ширину -->
                  <div class="mb-3 mt-3">
                    <v-autocomplete
                      v-model="editedHotspot.ids_nomenclatures"
                      :items="hotspotNomenclatureItems"
                      :item-text="getProductName"
                      item-value="id"
                      label="Номенклатура"
                      clearable
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      outlined
                      hide-details
                      class="hotspot-nomenclature"
                      :menu-props="{ maxHeight: '60vh' }"
                      :disabled="
                        $store.state.loadingRequestGeneral ||
                        !!editedHotspot.id ||
                        !selectedTemplateForHotspot
                      "
                    />
                  </div>
                  <v-btn
                    small
                    color="success"
                    :disabled="
                      !!editedHotspot.id ||
                      !editedHotspot.label_number ||
                      $store.state.loadingRequestGeneral
                    "
                    :loading="$store.state.loadingRequestGeneral"
                    @click="saveCurrentHotspot"
                  >
                    Сохранить метку
                  </v-btn>
                </div>
              </div>
            </template>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="!entry.id" class="text-caption grey--text mt-4">
      Введите название, чтобы создать запись и добавить фотографии
    </div>

    <v-snackbar v-model="snackbar" :timeout="6000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"
          >Закрыть</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import draggable from "vuedraggable";
import Request from "@/services/request";
import TextAreaStyled from "@/components/common/TextAreaStyled.vue";
import SearchStyled from "@/components/common/SearchStyled.vue";
import { mapState } from "vuex";

export default {
  name: "PrimeryKotelnyhEditor",
  components: {
    TextAreaStyled,
    SearchStyled,
    vueDropzone: vue2Dropzone,
    draggable,
  },
  data() {
    return {
      expandedPanels: [1],
      selectedSpecIndex: null,
      isAddingHotspot: false,
      editedHotspotIndex: null,
      imageLoaded: false,
      isDeletingAll: false,
      snackbar: false,
      snackbarText: "",
      debounceTimeout: null,
      draftTemplateRow: null,
      selectedTemplateForHotspot: null,
    };
  },
  computed: {
    ...mapState({
      entry: (state) => state.PrimeryKotelnyh.entry,
      listSpecs: (state) => state.PrimeryKotelnyh.listSpecs,
      listTemplateNomenclaturesSpec: (state) =>
        state.PrimeryKotelnyh.listTemplateNomenclaturesSpec,
    }),
    dropzoneOptions() {
      return {
        url: `${this.$store.state.BASE_URL}/entity/files`,
        destroyDropzone: false,
        headers: { Authorization: this.$store.getters.getToken },
        duplicateCheck: false,
        maxFiles: 1,
        acceptedFiles: "image/*",
        addRemoveLinks: false,
      };
    },
    selectedSpec() {
      if (this.selectedSpecIndex === null) return null;
      return this.listSpecs[this.selectedSpecIndex] || null;
    },
    editedHotspot() {
      if (!this.selectedSpec) return null;
      if (this.editedHotspotIndex === null) return null;
      return this.selectedSpec._hotspots?.[this.editedHotspotIndex] || null;
    },
    draggableTemplateList: {
      get() {
        return [...this.listTemplateNomenclaturesSpec].sort(
          (a, b) => (a.label_number || 0) - (b.label_number || 0)
        );
      },
      set(newList) {
        this.$store.commit(
          "PrimeryKotelnyh/setTemplateNomenclaturesSpec",
          newList
        );
      },
    },
    specTitleImage() {
      const tagId = this.selectedSpec?.id_tag;
      const tag = tagId
        ? this.$store.state.TagsModule.listTags.find((t) => t.id === tagId)
        : null;
      const tagName = tag?.name || "";
      const projectName = this.entry.name || "";
      if (!tagName && !projectName) return "";
      if (!tagName) return projectName;
      if (!projectName) return tagName;
      return `${tagName}: ${projectName}`;
    },
    hotspotNomenclatureItems() {
      const template = this.listTemplateNomenclaturesSpec.find(
        (t) => t.id === this.selectedTemplateForHotspot
      );
      if (!template) return this.$store.state.PrimeryKotelnyh.listNomenclatures;
      return this.$store.state.PrimeryKotelnyh.listNomenclatures.filter((n) =>
        template.ids_nomenclatures.includes(n.id)
      );
    },
  },
  async mounted() {
    this.$store.dispatch("Companies/getListCompanies");
    this.$store.dispatch("PrimeryKotelnyh/getListNomenclature");
    this.$store.dispatch("PrimeryKotelnyh/getListCities");
    this.$store.dispatch("PrimeryKotelnyh/getListModuleSchemes");
    this.$store.dispatch("getListTags");

    // Если редактируем существующую запись — загружаем спецификации и номенклатуру шаблона
    if (this.entry.id) {
      await Promise.all([
        this.$store.dispatch("PrimeryKotelnyh/loadSpecifications"),
        this.$store.dispatch("PrimeryKotelnyh/loadTemplateNomenclaturesSpec"),
      ]);
      if (this.listSpecs.length) this.selectedSpecIndex = 0;
    }
  },
  watch: {
    selectedSpecIndex() {
      this.editedHotspotIndex = null;
      this.isAddingHotspot = false;
      this.imageLoaded = false;
    },
    editedHotspotIndex(newVal) {
      this.selectedTemplateForHotspot = null;
      if (newVal === null || !this.editedHotspot) return;
      const hotspotIds = this.editedHotspot.ids_nomenclatures;
      if (!hotspotIds || !hotspotIds.length) return;
      const match = this.listTemplateNomenclaturesSpec.find((t) =>
        hotspotIds.every((id) => (t.ids_nomenclatures || []).includes(id))
      );
      if (match) this.selectedTemplateForHotspot = match.id;
    },
  },
  methods: {
    updateEntryLocal(key, value) {
      this.$store.commit("PrimeryKotelnyh/setEntryData", { [key]: value });
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(async () => {
        if (!this.entry.id) {
          if (!this.entry.name) return;
          await this.$store.dispatch("PrimeryKotelnyh/createEntry");
        } else {
          await this.$store.dispatch("PrimeryKotelnyh/updateEntry");
        }
      }, 1500);
    },

    async updateSpecTag(tagId) {
      if (!this.selectedSpec) return;
      const updated = { ...this.selectedSpec, id_tag: tagId };
      this.$store.commit("PrimeryKotelnyh/updateSpec", updated);
      await Request.put(
        `${this.$store.state.BASE_URL}/entity/specifications/${this.selectedSpec.id}`,
        updated
      );
    },

    // Дропзона
    onDropzoneSending(file, xhr, formData) {
      formData.append("uuid", file.upload.uuid);
    },
    async onSpecUploaded(file, response) {
      const newSpecId = await this.$store.dispatch(
        "PrimeryKotelnyh/addSpecification",
        response.data.id
      );
      this.$refs.dropzone.removeAllFiles();
      if (newSpecId !== null) {
        this.selectedSpecIndex = this.listSpecs.findIndex(
          (s) => s.id === newSpecId
        );
      }
    },
    async onRemoveSpec(specId) {
      if (!confirm("Удалить эту фотографию со всеми метками?")) return;
      const wasSelected = this.selectedSpec && this.selectedSpec.id === specId;
      await this.$store.dispatch("PrimeryKotelnyh/removeSpecification", specId);
      if (wasSelected) {
        this.selectedSpecIndex = this.listSpecs.length ? 0 : null;
        this.editedHotspotIndex = null;
      }
    },

    // Номенклатура шаблона
    getNomenclatureName(id) {
      const n = this.$store.state.PrimeryKotelnyh.listNomenclatures.find(
        (n) => n.id === id
      );
      if (!n) return `#${id}`;
      return [n._name_family, n.name].filter(Boolean).join(" — ");
    },
    addDraftTemplateRow() {
      const maxNum = this.listTemplateNomenclaturesSpec.reduce(
        (max, r) => Math.max(max, r.label_number || 0),
        0
      );
      this.draftTemplateRow = {
        label_number: maxNum + 1,
        id_tag: null,
        ids_nomenclatures: [],
        quantity: 1,
      };
    },
    cancelDraftTemplateRow() {
      this.draftTemplateRow = null;
    },
    async saveDraftTemplateRow() {
      if (!this.draftTemplateRow.ids_nomenclatures.length) {
        this.snackbarText = "Выберите хотя бы одну номенклатуру";
        this.snackbar = true;
        return;
      }
      this.$store.state.loadingRequestGeneral = true;
      try {
        const resp = await this.$store.dispatch(
          "PrimeryKotelnyh/createTemplateNomenclatureSpec",
          this.draftTemplateRow
        );
        if (resp.isError) throw new Error(resp.message);
        this.draftTemplateRow = null;
      } catch (e) {
        this.snackbarText = "Ошибка сохранения: " + e.message;
        this.snackbar = true;
      }
      this.$store.state.loadingRequestGeneral = false;
    },
    async onTemplateListDragEnd() {
      const rows = this.listTemplateNomenclaturesSpec;
      const changed = rows
        .map((row, i) => ({ row, newNum: i + 1 }))
        .filter(({ row, newNum }) => row.label_number !== newNum);
      if (!changed.length) return;

      // Карта: старый label_number → новый
      const labelNumMap = new Map(
        changed.map(({ row, newNum }) => [row.label_number, newNum])
      );

      // Локально обновляем шаблоны
      this.$store.commit(
        "PrimeryKotelnyh/setTemplateNomenclaturesSpec",
        rows.map((row, i) => ({ ...row, label_number: i + 1 }))
      );

      // Сохраняем шаблоны на бэкенде
      await Promise.all(
        changed.map(({ row, newNum }) =>
          this.$store.dispatch(
            "PrimeryKotelnyh/updateTemplateNomenclatureSpec",
            {
              id: row.id,
              payload: {
                ids_nomenclatures: row.ids_nomenclatures,
                id_tag: row.id_tag,
                quantity: row.quantity,
                label_number: newNum,
              },
            }
          )
        )
      );

      // Обновляем label_number на всех хотспотах которые используют изменившиеся номера
      const hotspotUpdates = [];
      const affectedSpecIds = new Set();
      for (const spec of this.listSpecs) {
        for (const hotspot of spec._hotspots || []) {
          if (!hotspot.id || !labelNumMap.has(hotspot.label_number)) continue;
          const newLabelNum = labelNumMap.get(hotspot.label_number);
          hotspot.label_number = newLabelNum;
          affectedSpecIds.add(spec.id);
          hotspotUpdates.push(
            Request.put(
              `${this.$store.state.BASE_URL}/m-to-o/specification-hotspots/${hotspot.id}`,
              {
                id_specification: hotspot.id_specification,
                ids_nomenclatures: hotspot.ids_nomenclatures || [],
                ids_families: hotspot.ids_families || [],
                hotspot_x: hotspot.hotspot_x,
                hotspot_y: hotspot.hotspot_y,
                quantity: hotspot.quantity,
                label_number: newLabelNum,
              }
            )
          );
        }
      }

      if (hotspotUpdates.length) {
        await Promise.all(hotspotUpdates);
        // Перегружаем затронутые спецификации — бэкенд регенерирует изображения
        await Promise.all(
          [...affectedSpecIds].map((specId) =>
            this.$store.dispatch("PrimeryKotelnyh/refreshSpec", specId)
          )
        );
      }
    },
    async deleteTemplateRow(id) {
      if (!confirm("Удалить строку?")) return;
      await this.$store.dispatch(
        "PrimeryKotelnyh/deleteTemplateNomenclatureSpec",
        id
      );
    },
    async onTemplateRowQtyChange(row, value) {
      const qty = parseInt(value, 10);
      if (!qty || qty < 1) return;
      await this.$store.dispatch(
        "PrimeryKotelnyh/updateTemplateNomenclatureSpec",
        {
          id: row.id,
          payload: {
            ids_nomenclatures: row.ids_nomenclatures,
            id_tag: row.id_tag,
            quantity: qty,
            label_number: row.label_number,
          },
        }
      );
    },

    // Хотспоты
    getTemplateName(template) {
      const tag =
        (template._tag && template._tag.name) || `тэг ${template.id_tag}`;
      const count = template.ids_nomenclatures
        ? template.ids_nomenclatures.length
        : 0;
      return `${template.label_number}. ${tag} (${count} номенкл.)`;
    },
    onTemplateSelectedForHotspot(templateId) {
      const template = this.listTemplateNomenclaturesSpec.find(
        (t) => t.id === templateId
      );
      if (!template || !this.editedHotspot) return;
      this.$set(this.editedHotspot, "ids_nomenclatures", [
        ...(template.ids_nomenclatures || []),
      ]);
      this.$set(this.editedHotspot, "quantity", template.quantity);
      this.$set(this.editedHotspot, "label_number", template.label_number);
    },
    getProductName(product) {
      return [product._name_category, product._name_family, product.name]
        .filter(Boolean)
        .join(" — ");
    },
    startAddHotspot() {
      this.isAddingHotspot = true;
      this.editedHotspotIndex = null;
    },
    onImageClick(e) {
      if (!this.isAddingHotspot || !this.imageLoaded || !this.selectedSpec)
        return;
      const rect = this.$refs.imageWrapper.getBoundingClientRect();
      const hotspot = {
        id: null,
        hotspot_x: Math.round(e.clientX - rect.left),
        hotspot_y: Math.round(e.clientY - rect.top),
        ids_nomenclatures: [],
        ids_families: [],
        id_specification: this.selectedSpec.id,
        quantity: 1,
        label_number: null,
      };
      this.selectedSpec._hotspots.push(hotspot);
      this.editedHotspotIndex = this.selectedSpec._hotspots.length - 1;
      this.isAddingHotspot = false;
    },
    async removeHotspot(index) {
      if (index === null || !this.selectedSpec) return;
      const hotspot = this.selectedSpec._hotspots[index];
      if (hotspot.id) {
        await Request.delete(
          `${this.$store.state.BASE_URL}/m-to-o/specification-hotspots/${hotspot.id}`
        );
        await this.$store.dispatch(
          "PrimeryKotelnyh/refreshSpec",
          this.selectedSpec.id
        );
      } else {
        this.selectedSpec._hotspots.splice(index, 1);
      }
      this.editedHotspotIndex = null;
      this.snackbarText = "Метка удалена";
      this.snackbar = true;
    },
    async clearAllHotspots() {
      if (!this.selectedSpec) return;
      if (
        !confirm(
          `Удалить все метки (${this.selectedSpec._hotspots.length} шт.)?`
        )
      )
        return;
      this.isDeletingAll = true;
      this.editedHotspotIndex = null;
      const saved = this.selectedSpec._hotspots.filter((h) => h.id);
      await Promise.all(
        saved.map((h) =>
          Request.delete(
            `${this.$store.state.BASE_URL}/m-to-o/specification-hotspots/${h.id}`
          )
        )
      );
      await this.$store.dispatch(
        "PrimeryKotelnyh/refreshSpec",
        this.selectedSpec.id
      );
      this.isDeletingAll = false;
    },
    async saveCurrentHotspot() {
      if (this.editedHotspotIndex === null || !this.editedHotspot) return;
      const hotspot = this.editedHotspot;
      if (!hotspot.ids_nomenclatures?.length && !hotspot.ids_families?.length) {
        this.snackbarText = "Выберите хотя бы одну номенклатуру";
        this.snackbar = true;
        return;
      }
      this.$store.state.loadingRequestGeneral = true;
      try {
        const response = await Request.post(
          `${this.$store.state.BASE_URL}/m-to-o/specification-hotspots`,
          {
            id_specification: hotspot.id_specification,
            ids_nomenclatures: hotspot.ids_nomenclatures || [],
            ids_families: hotspot.ids_families || [],
            hotspot_x: Math.round(hotspot.hotspot_x),
            hotspot_y: Math.round(hotspot.hotspot_y),
            quantity: hotspot.quantity || 1,
            label_number: hotspot.label_number ?? null,
          }
        );
        if (response.isError) throw new Error(response.message);
        await this.$store.dispatch(
          "PrimeryKotelnyh/refreshSpec",
          this.selectedSpec.id
        );
        this.editedHotspotIndex = null;
      } catch (e) {
        this.snackbarText = "Ошибка сохранения метки: " + e.message;
        this.snackbar = true;
      }
      this.$store.state.loadingRequestGeneral = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.template-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 4px 8px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: middle;
  }

  th {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
  }

  .drag-handle {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
}

.spec-thumb {
  position: relative;
  width: 100px;
  height: 80px;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
  }

  &__remove {
    position: absolute;
    top: 2px;
    right: 2px;
    background: white !important;
    opacity: 0;
    transition: opacity 0.15s;
  }

  &:hover &__remove {
    opacity: 1;
  }

  &--active {
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.3);
  }
}

.spec-dropzone {
  width: 100px;
  height: 80px;
  border: 2px dashed #bdbdbd !important;
  border-radius: 4px !important;
  min-height: unset !important;
  padding: 0 !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &.loading_dropzone {
    pointer-events: none;
    opacity: 0.6;
  }
}

::v-deep .nomenclature-autocomplete .v-select__selections {
  padding-top: 8px;
  padding-bottom: 4px;
  gap: 4px;
}

::v-deep .error-outlined .v-input__slot fieldset {
  border-color: #ff5252 !important;
}

.spec-editor-zone {
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 0;
}

.diagram-wrapper {
  position: relative;
  display: inline-block;
}

.diagram-image {
  display: block;
  object-fit: cover;
}

.hotspot-dot {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  background: #ff9800;

  &.saved {
    background: #4caf50;
  }

  &.editing {
    background: #f44336;
    transform: translate(-50%, -50%) scale(1.2);
  }

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }
}
</style>
